import { useNavigate, useParams } from 'react-router-dom';
import CardLayout from '../../../components/Layout/CardLayout';
import request from '../../../request/request';
import useFetch from '../../../hooks/useFetch';
import LoaderLayout from '../../../components/Loader/LoaderLayout';
import BlogFormContainer from '../../../components/Forms/Websites/Blogs/BlogFormContainer';
import { formDataConverter } from '../../../utils/necessaryFunctions';

const UpdateBlogs = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { result, isLoading } = useFetch(() => request.getOne('blogs', id));

    const UpdateAboutUsHandler = (formValue) => {
        const formData = formDataConverter(formValue);

        return request.updateOne('blogs', id, formData, () => {
            navigate('/dashboard/website/blogs');
        });
    };
    return (
        <LoaderLayout isPending={isLoading}>
            <CardLayout title='Update Blogs'>
                <BlogFormContainer apiHandler={UpdateAboutUsHandler} editData={result} />
            </CardLayout>
        </LoaderLayout>
    );
};

export default UpdateBlogs;
